import {isSidebarView} from '@/hooks/queryViewController';
import {openLinkByRuliu} from '@/utils/browserUtils';
import {isMac} from '@/utils/commonUtils';
import {MouseEvent, useState, useEffect} from 'react';
import {useHistory} from 'react-router-dom';
// import {feLogger, openPageUrl} from '../buried';
// import {getUrlInfo} from '../utils/urlUtils';

export enum UrlType {
    Repository = 1,
    Page,
    Group
}

export enum OpenType {
    newTab = 'newTab',
    currentTab = 'currentTab',
    comAndClickOpenNewTab = 'comAndClickOpenNewTab',
}
interface AnchorProps {
    url: string;
    urlType?: UrlType;
    ignoreClick?: boolean;
    children?: React.ReactNode | React.ReactNode[];
    className?: string;
    onClick?: (e?: MouseEvent) => void;
    openType?: OpenType;
    onMouseEnter?: (e: MouseEvent) => void;
}

export default function Anchor(props: AnchorProps) {
    const {
        url,
        ignoreClick = false,
        openType = OpenType.currentTab,
        children,
        className,
        onClick,
        onMouseEnter,
    } = props;
    const history = useHistory();
    const [openInNewTab, setOpenInNewTab] = useState(openType === OpenType.newTab);

    // eslint-disable-next-line complexity
    async function handleClick(e: MouseEvent) {
        onClick && onClick(e);
        if (e.defaultPrevented) {
            return;
        }
        if (ignoreClick) {
            e.preventDefault();
            return;
        }
        // 如果是sidebar视图，且跳转由anchor控制，则如流跳转
        if (isSidebarView()) {
            openLinkByRuliu(url);
        }
        if (
            openType === OpenType.comAndClickOpenNewTab
            && (isMac() && e?.metaKey) || (!isMac() && e?.ctrlKey)
        ) {
            setOpenInNewTab(true);
            return;
        }
        if (!ignoreClick && openInNewTab) {
            return;
        }
        e.preventDefault();
        history.push(url);
    }
    useEffect(() => {
        if (openType === OpenType.comAndClickOpenNewTab && openInNewTab) {
            setOpenInNewTab(false);
        }
    }, [openInNewTab, openType]);
    function handleDragStart(e: MouseEvent) {
        e.preventDefault();
        return false;
    }

    function handleMouseEnter(e: MouseEvent) {
        onMouseEnter && onMouseEnter(e);
    }
    return (
        <a
            rel="noreferrer"
            href={url}
            onClick={handleClick}
            onDragStart={handleDragStart}
            className={className}
            target={openInNewTab ? '_blank' : ''}
            onMouseEnter={handleMouseEnter}
        >
            {children}
        </a>
    );
}
